export const pictureDetailedVODPageTestIDs = {
  pictureDetailedVODPage: 'picture_detailed_vod_page',
  mainLayout: 'picture_detailed_vod_sesons',
  headerArea: 'picture_detailed_vod_header',
  showTitle: 'picture_detailed_vod_title_',
  episodesTiles: 'picture_detailed_episodes',
  seasonsMenu: 'picture_detailed_seasons_menu',
  readMoreButton: 'picture_detailed_read_more_button',
  restartButton: 'picture_detailed_restart_button',
};
